import { AvailableCryptoCurrenciesList } from 'shared/models/Crypto'

import { PaymentMethodsType, transactionStatusesType } from '../types/common'

export const cryptoCurrenciesWhiteList: AvailableCryptoCurrenciesList[] = [
  'btc',
  'eth',
  'usdttrc20',
  'usdterc20',
  'busdbsc',
  'bnbbsc',
  'doge',
  'trx',
  'ltc',
]

export const paymentSystemMethodsSortList: PaymentMethodsType[] = []

export const availablePaymentStatusesForCancel: transactionStatusesType[] = [
  'ManualApprovingRequired',
  'ManualProcessRequired',
  'Approving',
]
